import axios, { handleRequest, setAuthorizationToken } from './api-connecting'


export const ContentListAPI = () => handleRequest(axios.get('/admin/content/list',).then(data => data))
export const ContentCreateAPI = (params) => handleRequest(axios.post('/admin/content', params).then(data => data))
export const ContentEditAPI = (id, params) => handleRequest(axios.patch(`/admin/content/update/${id}`, params).then(data => data))